/** List all outstanding invitations for the tenant (tenant admins). */
export const tenantUserInvitationListSpec = {
    uri: '/t/[tenant]/user/invitation',
    method: 'POST',
};
